<div [formGroup]="form" [readonly]="!canEdit">
  <div class="row">
    <div class="col-12 no-padding">
      <div class="f-1 flex">
        <div class="f-1 flex flex-col">
          <div class="f-1 align-center mb10 flex flex-row">
            <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.picking_unit"
              for="pickingUnitId"
              description="cards.products.product_packaging_edit_basic_unit.label_description.picking_unit"
              [required]="canEdit"
              [validationResultType]="isFieldInvalid(ProductUnitField.PickingUnit, form.get('pickingUnitId').value)">
              <lxm-select any class="dialog-input-fixed-width-3" for="pickingUnitId" value="id"
                [options]="formData.units" [searchable]="true" labelField="translatedValue" [isTranslated]="true"
                [clearable]="false" [sortByLabel]="true" [readonly]="!canEdit">
              </lxm-select>
              <validation-errors for="pickingUnitId"></validation-errors>
            </form-field>
            <lxm-checkbox class="ml10" for="hasVariableWeight"
              label="cards.products.product_packaging_edit_basic_unit.label.has_variable_weight"
              [readonly]="!canEdit"></lxm-checkbox>
          </div>
        </div>
      </div>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_ordering.label"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_ordering"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsOrderUnit, form.get('isOrderUnit').value)">
        <slide-toggle toggle for="isOrderUnit" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isOrderUnit"></validation-errors>
      </form-field>

      <form-field dialog for="minOrderCount" *ngIf="form.value.isOrderUnit"
        label="cards.products.product_packaging_edit_basic_unit.label.min_order_count"
        description="cards.products.product_packaging_edit_basic_unit.label_description.min_order_count"
        [validationResultType]="isFieldInvalid(ProductUnitField.MinOrderCount, form.get('minOrderCount').value)">
        <lxm-input class="dialog-input-fixed-width-1" for="minOrderCount" type="numeric" [allowNegativeNumbers]="false"
          [digits]="2" [readonly]="!canEdit"></lxm-input>
        <validation-errors for="minOrderCount"></validation-errors>
      </form-field>

      <form-field dialog for="minOrderCountMultiplier" *ngIf="form.value.isOrderUnit"
        label="cards.products.product_packaging_edit_basic_unit.label.min_order_count_multiplier"
        description="cards.products.product_packaging_edit_basic_unit.label_description.min_order_count_multiplier"
        [validationResultType]="isFieldInvalid(ProductUnitField.MinOrderCountMultiplier, form.get('minOrderCountMultiplier').value)">
        <lxm-input class="dialog-input-fixed-width-1" for="minOrderCountMultiplier" type="numeric"
          [allowNegativeNumbers]="false" [digits]="2" [readonly]="!canEdit"></lxm-input>
        <validation-errors for="minOrderCountMultiplier"></validation-errors>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.deposit"
        description="cards.products.product_packaging_edit_basic_unit.label_description.deposit"
        [validationResultType]="isFieldInvalid(ProductUnitField.PackageDeposits, form.get('packageDeposits').value)">
        <deposit-manager [readonly]="!canEdit" any for="packageDeposits" [depositOptions]="formData.packageDepositTypes"
          [readonly]="!canEdit"></deposit-manager>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.package_material"
        description="cards.products.product_packaging_edit_basic_unit.label_description.package_material"
        [validationResultType]="productValidity.shouldValidate ? isFieldInvalid(ProductUnitField.PackageMaterials, form.get('packageMaterials').value) : (canEdit ? ValidationResultType.Recommended : ValidationResultType.None)">
        <package-material-manager [readonly]="!canEdit" any for="packageMaterials"
          [materialOptions]="formData.packageMaterialTypes"></package-material-manager>
      </form-field>
    </div>
  </div>
  <div class="separator"></div>
  <div class="row">
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_net_weight"
        for="netWeight_g"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_net_weight"
        [required]="canEdit"
        [validationResultType]="isFieldInvalid(ProductUnitField.NetWeight, form.get('netWeight_g').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="netWeight_g" [readonly]="!canEdit">
          <span suffix>{{'enums.UnitShort.Gram' | translate}}</span>
          <validation-errors for="netWeight_g"></validation-errors>
        </combined-input>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_gross_weight"
        for="grossWeight_g"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_gross_weight"
        [validationResultType]="isFieldInvalid(ProductUnitField.GrossWeight, form.get('grossWeight_g').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="grossWeight_g" [readonly]="true">
          <span suffix>{{'enums.UnitShort.Gram' | translate}}</span>
          <validation-errors for="grossWeight_g"></validation-errors>
        </combined-input>
      </form-field>
    </div>
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_height" for="height_mm"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_height"
        [required]="canEdit"
        [validationResultType]="isFieldInvalid(ProductUnitField.Height, form.get('height_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="height_mm" [readonly]="!canEdit">
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="height_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_width" for="width_mm"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_width" [required]="canEdit"
        [validationResultType]="isFieldInvalid(ProductUnitField.Width, form.get('width_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="width_mm" [readonly]="!canEdit">
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="width_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_length" for="length_mm"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_length"
        [required]="canEdit"
        [validationResultType]="isFieldInvalid(ProductUnitField.Length, form.get('length_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="length_mm" [readonly]="!canEdit">
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="length_mm"></validation-errors>
        </combined-input>
      </form-field>
    </div>
  </div>

  <card-message type="error" *ngIf="!subUnitHasNetAndGrossWeight" class="mb10">
    {{'cards.products.product_packaging.sub_unit_invalid_warning' | translate}}
  </card-message>

  <card-message type="warning" *ngIf="packageCapacityCheckFailed" class="mb10">
    {{ packageCapacityCheckError?.value | translate:
    packageCapacityCheckError?.args }}
  </card-message>

  <card-message type="message" *ngIf="userHasChangedHeight" class="mb10">
    {{'cards.products.product_packaging_edit_pallet.warning_message.height_manual_change'
    | translate}}
  </card-message>

  <div class="separator"></div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.is_compressable.label"
        description="cards.products.product_packaging_edit_basic_unit.label_description.is_compressable"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsCompressable, form.get('isCompressable').value)">
        <slide-toggle toggle for="isCompressable" [readonly]="!canEdit"></slide-toggle>
      </form-field>
    </div>

    <div class="col-6 no-padding">
      <form-field dialog *ngIf="form.get('isCompressable')?.value" for="compressedHeight_mm"
        label="cards.products.product_packaging_edit_basic_unit.label.unit_compressed_height"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_compressed_height"
        [validationResultType]="isFieldInvalid(ProductUnitField.CompressedHeight, form.get('compressedHeight_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="compressedHeight_mm" [readonly]="!canEdit">
          <span suffix>mm</span>
          <validation-errors for="compressedHeight_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field dialog *ngIf="form.get('isCompressable')?.value" for="compressedWidth_mm"
        label="cards.products.product_packaging_edit_basic_unit.label.unit_compressed_width"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_compressed_width"
        [validationResultType]="isFieldInvalid(ProductUnitField.CompressedWidth, form.get('compressedWidth_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="compressedWidth_mm" [readonly]="!canEdit">
          <span suffix>mm</span>
          <validation-errors for="compressedWidth_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field dialog *ngIf="form.get('isCompressable')?.value" for="compressedLength_mm"
        label="cards.products.product_packaging_edit_basic_unit.label.unit_compressed_length"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_compressed_length"
        [validationResultType]="isFieldInvalid(ProductUnitField.CompressedLength, form.get('compressedLength_mm').value)">
        <combined-input any class="dialog-input-fixed-width-1" for="compressedLength_mm" [readonly]="!canEdit">
          <span suffix>mm</span>
          <validation-errors for="compressedLength_mm"></validation-errors>
        </combined-input>
      </form-field>
    </div>
  </div>

  <div class="separator"></div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_package_type"
        for="packageTypeId"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_package_type"
        [descriptionParams]="{ guideLink: packagingGuideLink }" [interactiveDescription]="true" [required]="canEdit"
        [validationResultType]="isFieldInvalid(ProductUnitField.PackageType, form.get('packageTypeId').value)">
        <lxm-select any class="dialog-input-fixed-width-3" for="packageTypeId" [options]="formData.packageTypes"
          [searchable]="true" value="id" labelField="translatedValue" [isTranslated]="true" [sortByLabel]="true"
          [clearable]="false" [readonly]="!canEdit">
        </lxm-select>
        <validation-errors for="packageType"></validation-errors>
        <validation-errors for="packageTypeId"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field dialog for="packageName"
        label="cards.products.product_packaging_edit_basic_unit.label.unit_package_name"
        [validationResultType]="isFieldInvalid(ProductUnitField.PackageName, form.get('packageName').value)">
        <lxm-input any class="dialog-input-fixed-width-3" for="packageName" [readonly]="!canEdit"></lxm-input>
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.unit_package_name" -->
        <validation-errors for="packageName"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row align-center">
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.unit_is_package_reusable"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_is_package_reusable"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsReusablePackage, form.get('isReusablePackage').value)">
        <slide-toggle toggle for="isReusablePackage" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isReusablePackage"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding">

    </div>
  </div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.has_peghole.label"
        description="cards.products.product_packaging_edit_basic_unit.label_description.has_peghole"
        [validationResultType]="isFieldInvalid(ProductUnitField.HasPegHole, form.get('hasPegHole').value)">
        <slide-toggle toggle for="hasPegHole" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="hasPegHole"></validation-errors>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.is_stackable.label"
        for="maxStack" description="cards.products.product_packaging_edit_basic_unit.label_description.is_stackable"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsStackable, form.get('isStackable').value)">
        <div any row class="f-1 justify-between">
          <slide-toggle for="isStackable"></slide-toggle>
          <div *ngIf="form.get('isStackable')?.value">
            <combined-input any for="maxStack" [readonly]="!canEdit" [isValid]="form.get('maxStack').valid" class="ml10"
              style="flex: 0 !important; width: 100px; min-width: 100px">
              <span suffix>{{'enums.UnitShort.Piece' | translate}}</span>
              <validation-errors for="maxStack"></validation-errors>
            </combined-input>
          </div>
        </div>
      </form-field>
    </div>
    <div class="col-6 no-padding"></div>
  </div>

  <div class="separator"></div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field dialog for="labelMeasures" type="input-text"
        label="cards.products.product_packaging_edit_basic_unit.label.label_measures"
        [validationResultType]="isFieldInvalid(ProductUnitField.LabelMeasures, form.get('labelMeasures').value)">
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.label_measures" -->

        <validation-errors for="labelMeasures"></validation-errors>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.label_eto_package_sign"
        [validationResultType]="isFieldInvalid(ProductUnitField.LabelEtoPackageSign, form.get('labelEtoPackageSign').value)">
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.label_eto_package_sign" -->

        <slide-toggle toggle for="labelEtoPackageSign" [readonly]="!canEdit"></slide-toggle>
      </form-field>
    </div>
    <div class="col-6 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.label_type" for="labelTypeIds"
        [validationResultType]="isFieldInvalid(ProductUnitField.LabelType, form.get('labelTypeIds').value)">
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.label_type" -->

        <lxm-select for="labelTypeIds" [options]="formData.labelTypes" [searchable]="true" value="id"
          labelField="translatedValue" [isTranslated]="true" [sortByLabel]="true" [clearable]="true"
          [readonly]="!canEdit" [multiple]="true">
        </lxm-select>
        <validation-errors for="labels"></validation-errors>
      </form-field>

      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.label_film_type"
        for="labelFilmTypeId"
        [validationResultType]="isFieldInvalid(ProductUnitField.LabelFilmType, form.get('labelFilmTypeId').value)">
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.label_film_type" -->

        <lxm-select for="labelFilmTypeId" [options]="formData.labelFilmTypes" [searchable]="true" value="id"
          labelField="translatedValue" [isTranslated]="true" [sortByLabel]="true" [clearable]="true"
          [readonly]="!canEdit">
        </lxm-select>
        <validation-errors for="labelFilmType"></validation-errors>
        <validation-errors for="labelFilmTypeId"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field dialog label="cards.products.product_packaging_edit_basic_unit.label.packaging_handling_pictograms"
        for="packagingHandlingPictogramIds"
        [validationResultType]="isFieldInvalid(ProductUnitField.PackagingHandlingPictograms, form.get('packagingHandlingPictogramIds').value)">
        <!-- description="cards.products.product_packaging_edit_basic_unit.label_description.packaging_handling_pictograms" -->

        <lxm-select class="dialog-input-fixed-width-3" for="packagingHandlingPictogramIds"
          [options]="formData.packagingHandlingPictograms" [searchable]="true" value="id" labelField="translatedValue"
          [isTranslated]="true" [sortByLabel]="true" [clearable]="true" [readonly]="!canEdit" [multiple]="true">
        </lxm-select>
        <validation-errors for="packagingHandlingPictograms"></validation-errors>
      </form-field>
    </div>
  </div>
</div>